<template>
    <div class="no__print">
        <!-- <div v-show="!isPrintmode"> -->
        <q-header reveal class="bg-white text-black" style="border-bottom: 1px solid #e0e0e0">
            <q-toolbar style="justify-content: space-between; padding: 0 2vw">
                <div style="height: 7.17vmin; display: flex; align-items: center">
                    <q-icon name="img:/assets/images/icon/ico_home.svg" :onclick="onHome" style="width: 2vw; height: 2vw; cursor: pointer" />
                    <div class="header_lesson q-px-sm b1"><b> 진단평가 분석리포트</b></div>
                </div>
<!--                <div v-if="gStore?.platform === 'DESKTOP'">
                    <q-icon name="img:/assets/images/icon/ico_report_print.svg" :onclick="onPrint" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
                </div>-->
            </q-toolbar>
        </q-header>
        <q-page-container>
            <q-page>
                <ReportContent v-if="reportData" :report-data="reportData" :diagnostic-seq="diagnosticSeq" />
            </q-page>
        </q-page-container>
    </div>

    <!-- <div v-show="isPrintmode"> -->
    <div class="print_area">
        <PrintReportContent v-if="reportData" :reportData="reportData" :isPrintMode="isPrintmode" :isAnalysisMenu="isAnalysisMenu" />
    </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue';
import { apiGetEvalList, apiGetEvalReport4NonMember, apiGetEvalReport4Member } from '@/api/modules/eval_api.js';
import _ from 'lodash';
import { useRouter, useRoute } from 'vue-router';
import ReportContent from '../report/diagnosticReport/reportContent.vue';
import PrintReportContent from '../report/diagnosticReport/printReportContent.vue';
import { GlobalStore } from '@/store';
import { DialogStore } from '@/store/modules/dialog';

import { useQuasar } from 'quasar';

import Comm from '@/components/common.js';
import { monitoringLog } from '@/api/modules/monitoring';

const $q = useQuasar();
const router = useRouter();
const route = useRoute();
const gStore = GlobalStore();
const reportData = ref(null);
const dStore = DialogStore();
const isPrintmode = ref(false);
const diagnosticSeq = ref(null);

const isAnalysisMenu = ref(false);

const beforePrint = () => {
    isPrintmode.value = true;
};
const afterPrint = () => {
    isPrintmode.value = false;
};

window.onbeforeprint = beforePrint;
window.onafterprint = afterPrint;

const onPrint = () => {
    // isPrintmode.value = true;
    isPrintmode.value = true;
    setTimeout(() => {
        window.print();
    }, 500);
};

const checkConfirm = (val) => {
    val && router.push('/learninghome');
};

const onHome = () => {
    dStore.openSelect('홈으로 이동하시겠습니까?', (val) => {
        if (val) router.push(gStore.is_member_eval ? '/learninghome' : '/eval-login');
    });
};

const setData = (resData) => {
    reportData.value = resData;
    // report.value = resData;
    // console.log('--getReport-commentAnalysis-', reportData.value.data.commentAnalysis);
    //  setTableData(resData.data.literatureResult, tableDataLiter, 0);
    // setTableData(resData.data.nonLiteratureResult, tableDataNon, 15);
};

const setDataForMember = async () => {
    const resList = await apiGetEvalList();
    if (resList)
        if (resList.status === 200) {
            const list = resList.data.data.sort((a, b) => b.diagnosticSeq - a.diagnosticSeq);
            // console.log('-setDataForMember-after-list--', list);
            const lastCompletedData = list[0];
            diagnosticSeq.value = lastCompletedData.diagnosticSeq;

            const res = await apiGetEvalReport4Member(lastCompletedData.diagnosticSeq);

            if (res) if (res.status === 200) setData(res.data.data);
        }
};
const setDataForNoneMember = async () => {
    // console.log('----setDataForNoneMember');
    const res = await apiGetEvalReport4NonMember(gStore.evalData.nick, gStore.evalData.academy_code);
    if (res) if (res.status === 200) setData(res.data.data);
};

onMounted(() => {
    Comm.setDeviceType();
    // 회원 분기
    gStore.is_member_eval ? setDataForMember() : setDataForNoneMember();
    // route path
    // console.log(route.path);
    isAnalysisMenu.value = route.path === '/analysisreport' ? true : false;

    let data = {
        menuName: route.path.split('/').join(''),
    };
    monitoringLog(data, (res) => {
        console.log('eval_report monitoringLog API response ===', res);
    });
});
</script>

<style scoped lang="scss">
.print_area {
    visibility: hidden;
    position: absolute;
    right: 0;
    // display: contents;

    // visibility: visible;
    // display: block;
}

.no__print {
    visibility: visible;
    display: block;
    // visibility: hidden;
    // display: none;
}

@media print {
    .no__print {
        visibility: hidden;
        display: none;
    }

    .print_area {
        visibility: visible;
        display: contents;
        margin-bottom: 10px;
    }
}
</style>
